import { Injectable } from '@angular/core';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
//import * as Excel from "exceljs"
//import { Workbook } from 'exceljs/dist/exceljs.min.js';
//import * as fs from 'file-saver';
//import * as logoFile from './carlogo.js';
import { DatePipe } from '@angular/common';

type AOA = any[][];


const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

@Injectable()
export class ExcelService {
  wopts: XLSX.WritingOptions = { bookType: 'xlsx', type: 'array' };
  constructor(private datePipe: DatePipe) { }

  public exportAsExcelFile(json: any[], excelFileName: string, excelSheetName?: string): void {

    const sheetName = excelSheetName !== undefined ? excelSheetName : 'data';
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);

    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: [sheetName] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

    this.saveAsExcelFile(excelBuffer, excelFileName);
  }

  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName + EXCEL_EXTENSION);
  }

  public readWorkBookToArray(e: any): any {

    /* read workbook */
    const bstr: string = e.target.result;
    const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });

    /* grab first sheet */
    const wsname: string = wb.SheetNames[0];
    const ws: XLSX.WorkSheet = wb.Sheets[wsname];

    /* save data */
    return <AOA>(XLSX.utils.sheet_to_json(ws, { header: 1 }));

  }

  public readWorkBookToHtml(e: any): any {
    const bstr: string = e.target.result;
    const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });

    /* grab first sheet */
    const wsname: string = wb.SheetNames[0];
    const ws: XLSX.WorkSheet = wb.Sheets[wsname];

    /* save data */
    return XLSX.utils.sheet_to_html(ws, { editable: true, id: 'datatb' });
  }

  public export(dataA: any, fileName: string): void {
    /* generate worksheet */
    const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(dataA);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, fileName);
  }

  public readWorkBookToArrayForCanvasDataGrid(e: any): any {

    /* read workbook */
    const bstr: string = e.target.result;
    const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary', raw: true });

    /* grab first sheet */
    const wsname: string = wb.SheetNames[0];
    const ws: XLSX.WorkSheet = wb.Sheets[wsname];

    /* save data */
    return <AOA>(XLSX.utils.sheet_to_json(ws, { header: 1, blankrows: true, defval: '', raw: true }));

  }

  public readWorkBookToArrayForCanvasDataGridBinary(e: any, workSheetName: string, regionFlag: string): any {

    /* read workbook */
    const bstr: string = e;
    //const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary', raw: true });
    const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary', raw: true, cellDates: true, cellNF: false, cellText: false });

    /* grab first sheet */
    // const wsname: string = wb.SheetNames[0];
    const ws: XLSX.WorkSheet = wb.Sheets[workSheetName];

    /* save data */
    const range = XLSX.utils.decode_range(ws['!ref']);
    range.s.r = 0;
    range.s.c = 0;
    const new_range = XLSX.utils.encode_range(range);

    // return <AOA>(XLSX.utils.sheet_to_json(ws, { header: 1, defval: '', blankrows: true, raw: false, range: new_range }));
    if (regionFlag == '1') {
      return <AOA>(XLSX.utils.sheet_to_json(ws, { header: 1, defval: '', blankrows: true, raw: false, range: new_range, dateNF: "MM-DD-YYYY" }));
    }
    else {
      return <AOA>(XLSX.utils.sheet_to_json(ws, { header: 1, defval: '', blankrows: true, raw: false, range: new_range, dateNF: "DD-MM-YYYY" }));
    }


  }

  public readWorkSheetNames(e: any): string[] {
    const bstr: string = e;
    const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary', raw: true, bookSheets: true });
    return wb.SheetNames;
  }

  public readFile(fileName) {
    return XLSX.readFile(fileName);
  }
}
